import React, { useContext } from 'react';
import { CustomDrawer, CustomModal, DataList, DrawerContext } from 'commons-ui';

import { DEFAULT_CONFIG } from './helper';
import useSettingsActions from '../../../../useSettingsActions';
import { LIST_ENTITY_NAMES } from '../../../../../../settingsV2Constant';

import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { columnConfigs } from './listConfig';

const PermissionsSetList: React.FC<{}> = () => {
	const { getPermissionsSetData, forceUpdate, setForceUpdate, turnForceUpdateOff } = useService();
	const { drawerConfig, setDrawerConfig } = useContext(DrawerContext);
	const { getActionHandler, getActionList } = useSettingsActions(makeActionHandler, makeActionList, {
		setForceUpdate
	});
	const actions = getActionList();
	return (
		<>
			<DataList
				defaults={DEFAULT_CONFIG}
				fetchData={getPermissionsSetData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				globalForceUpdate={forceUpdate}
				turnGlobalForceUpdateOff={turnForceUpdateOff}
				entity={LIST_ENTITY_NAMES.PERMISSIONS_SET}
				height='calc(100vh - 220px)'
			/>
			<CustomDrawer drawerConfig={drawerConfig} setDrawerConfig={setDrawerConfig} />
			<CustomModal />
		</>
	);
};

export default PermissionsSetList;
